"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SwmcFooter", {
  enumerable: true,
  get: function () {
    return _SwmcFooter.default;
  }
});
var _SwmcFooter = _interopRequireDefault(require("./SwmcFooter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }